import { Box, Button, Container, styled } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Col, Row } from 'react-bootstrap'
import Loading from "react-loading";

const ButtonCustom = styled(Button)({
  width: "300px",
  borderRadius: "16px",
  backgroundColor: "#fff",
  color: "#5382C2",
  fontSize: '16px',
  fontWeight: '400',
  '&:hover': {
    backgroundColor: "#B6E4FE",
    color: "#5382C2",
    boxShadow: "3px 2px 1px 0 rgba(0,0,0,0.12)"
  }
})
const Content = styled(Box)({
  // width:"100%",
  // border:"2px solid red",
  height: 'auto',
  minHeight: "auto",
  display: "flex",
  flex: "1 1 200px",
  flexWrap: "wrap",
  justifyContent: "center",
  alignItems: "center",
  gap: "2em 2em",
  '.detail-box-content': {
    width: "300px",
    // border:'2px solid red',
    height: "300px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "1px 3px 2px 3px rgba(0,0,0,0.2)"
  }
})
const Detail = () => {
  const { detailId } = useParams();
  const [pageState, setPageState] = useState("PAGEONE")

  return (
    <Container fluid>
      <Row>
        <Col xl={2} md={2} sm={3} className="p-3 d-flex justify-content-center align-items-center">
          <ButtonCustom
              sx={{backgroundColor:pageState === "PAGEONE" ? "#000":"#fff"}}
            onClick={() => setPageState("PAGEONE")} variant="outlined" className="btn btn-success p-2 ">ผลสุขภาพ</ButtonCustom>
        </Col>
        <Col xl={2} md={2} sm={4} className="p-3 d-flex justify-content-center align-items-center">
          <ButtonCustom
            sx={{backgroundColor:pageState === "PAGETWO" ? "#000":"#fff"}}
            onClick={() => setPageState("PAGETWO")} variant="outlined" className="btn btn-primary p-2 ">ประวัติการค้นหา</ButtonCustom>
        </Col>
        <Col xl={2} md={2} sm={3} className="p-3 d-flex justify-content-center align-items-center">
          <ButtonCustom
            sx={{backgroundColor:pageState === "PAGETHREE" ? "#000":"#fff"}}
            onClick={() => setPageState("PAGETHREE")} variant="outlined" className="btn btn-info p-2 ">ประวัติวัคซีน</ButtonCustom>
        </Col>
      </Row>
      {pageState === "PAGEONE" && (
        <Content>
          <Box className="detail-box-content">box1 fristpage</Box>
          <Box className="detail-box-content">box2 fristpage</Box>
          <Box className="detail-box-content">box3 fristpage</Box>
          <Box className="detail-box-content">box4 fristpage</Box>
          <Box className="detail-box-content">box5 fristpage</Box>
          <Box className="detail-box-content">box6 fristpage</Box>
        </Content>
      )}
      {pageState === "PAGETWO" && (
        <Content>
          <Box className="detail-box-content">box1 secondPage</Box>
          <Box className="detail-box-content">box2 secondPage</Box>
          <Box className="detail-box-content">box3 secondPage</Box>
          <Box className="detail-box-content">box4 secondPage</Box>
          <Box className="detail-box-content">box5 secondPage</Box>
          <Box className="detail-box-content">box6 secondPage</Box>
        </Content>
      )}
      {pageState === "PAGETHREE" && (
        <Content>
          <Box className="detail-box-content">box1 thirdPage</Box>
          <Box className="detail-box-content">box2 thirdPage</Box>
          <Box className="detail-box-content">box3 thirdPage</Box>
          <Box className="detail-box-content">box4 thirdPage</Box>
          <Box className="detail-box-content">box5 thirdPage</Box>
          <Box className="detail-box-content">box6 thirdPage</Box>
        </Content>
      )}
    </Container>
  );
};

export default Detail;
